import React, { useState, memo, useEffect } from 'react';
import {
  ListItem,
  ListItemText,
  IconButton,
  Collapse,
  Tooltip,
  Box // Import Box if LayerDetails is rendered directly inside Collapse without Paper
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import LayersIcon from '@mui/icons-material/Layers';
import DeleteIcon from '@mui/icons-material/Delete';
import LayerDetails from './LayerDetails'; // Import the new component

function LayerListItem({
  layer,
  onDeleteLayer, // Pass handler from LayerInfo
  isReadOnly, // Add isReadOnly
  layerDetailsProps // Bundled props for LayerDetails
}) {
  const [expanded, setExpanded] = useState(false);

  const handleToggleExpand = () => {
    setExpanded(!expanded);
  };

  const handleDelete = (e) => {
    e.stopPropagation(); // Prevent triggering expand/collapse
    onDeleteLayer(layer);
  };

  // Determine the unit description for display
  // Access domainValues from layerDetailsProps for unit description
  const unitDescription = layer.upperdepth_uom 
    ? (layerDetailsProps.domainValues?.['Eenheid']?.find(unit => unit.domain_value_id === layer.upperdepth_uom)?.description || `ID: ${layer.upperdepth_uom.substring(0,4)}?`) 
    : '';

  return (
    <React.Fragment>
      <ListItem
        button
        onClick={handleToggleExpand}
        sx={{
          borderLeft: '1px solid',
          borderLeftColor: 'divider',
          pl: 2
        }}
      >
        <LayersIcon fontSize="small" sx={{ mr: 2, color: 'secondary.main' }} />
        <ListItemText
          primary={`${layer.upperdepth ?? '0'} - ${layer.lowerdepth ?? '?'} ${unitDescription}`}
          secondary={null} // Or perhaps show layer type here if available and concise?
        />
        <Tooltip title="Verwijder laag">
          <IconButton
            edge="end"
            size="small"
            color="error"
            onClick={handleDelete}
            sx={{ mr: 1 }}
            disabled={isReadOnly} // Add disabled
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <IconButton edge="end" size="small">
          {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </ListItem>

      <Collapse in={expanded} timeout="auto" unmountOnExit>
        {/* Render LayerDetails when expanded, passing all necessary props */}
        {/* Spread layerDetailsProps to pass them to LayerDetails */}
        <LayerDetails 
            {...layerDetailsProps}
        />
      </Collapse>
    </React.Fragment>
  );
}

// Use memo to prevent unnecessary re-renders if props haven't changed
export default memo(LayerListItem); 